// Material
import { styled } from '@mui/material/styles'
import { alpha, Button } from '@mui/material'

const StyledButton = styled(Button)<{
  dataColor?: string
  dataBackgroundColor?: string
}>`
  background-color: ${({ theme, dataBackgroundColor }) =>
    dataBackgroundColor || theme.palette.neutral700};
  min-height: 36px;
  color: ${({ theme, dataColor }) => dataColor || theme.palette.neutral000};
  border-radius: 12px;
  padding: 8px 16px;

  .MuiButton-startIcon {
    margin-left: 4px;
    margin-right: 0;
  }
  ,
  &:hover {
    color: ${({ theme, dataColor }) => dataColor || theme.palette.neutral000};
    background-color: ${({ theme, dataBackgroundColor }) =>
      dataBackgroundColor || theme.palette.neutral700};
  }
`

interface Props {
  title: string
  onClick: () => any
  icon: any
  color?: string
  backgroundColor?: string
  size?: 'small' | 'medium' | 'large'
}
export function RoundedContainedButton({
  title,
  icon,
  onClick,
  color,
  size = 'medium',
  backgroundColor,
}: Props) {
  return (
    <StyledButton
      variant="contained"
      startIcon={icon}
      onClick={onClick}
      dataColor={color}
      dataBackgroundColor={backgroundColor}
      size={size}
    >
      {title}
    </StyledButton>
  )
}
